<template>
  <div class="fullEditor">
    <Signature
      :data="data"
      v-if="isCompletedQuote"
      :isEditingSignatureFunction="isEditingSignatureFunction"
      :isEditingSignature="isEditingSignature"
    />
    <Editor
      v-model="$v[validationGroupName].sections.bookMyGroup.$model"
      @blur="$v[validationGroupName].sections.bookMyGroup.$touch()"
      :validator="$v[validationGroupName].sections.bookMyGroup"
      :showDebugger="false"
      :disabled="isCompletedQuote"
    />
  </div>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'
import Signature from '@/components/_shared/Signature.vue'

export default {
  name: 'TabBookMyGroup',
  data () {
    return {
      isEditingSignature: false
    }
  },
  inject: ['$v'],
  components: { Editor, Signature },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    },
    data: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: true,
      default: () => {}
    }
  },
  methods: {
    isEditingSignatureFunction () {
      this.isEditingSignature = !this.isEditingSignature
      return true
    }
  }
}
</script>
